var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-tooltip',{attrs:{"text":_vm.$t('reset_password')}},[_c('vs-button',{attrs:{"color":"primary","type":"filled","icon-pack":"feather","icon":"icon-lock","size":"small"},on:{"click":function($event){$event.preventDefault();return _vm.resetPassword.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }